import { api } from "./client";

export type AuditDiff = Record<string, unknown> | null;

export type AuditRow = {
  id: string;
  created_at: string | null;
  actor: string;
  entity_type: string;
  entity_id: string;
  creator_email: string | null;
  action: string;
  reason: string | null;
  diff: AuditDiff;
};

export type AuditSortField = "created_at" | "actor" | "action" | "entity_type";
export type SortDir = "asc" | "desc";

export type AuditListResponse = {
  audits: AuditRow[];
  page: number;
  page_size: number;
  total: number;
  sort: AuditSortField;
  dir: SortDir;
};

export type AuditListParams = {
  page: number;
  page_size?: number;
  q?: string;
  created_after?: string;
  created_before?: string;
  sort?: AuditSortField;
  dir?: SortDir;
};

export const AuditsApi = {
  list(params: AuditListParams) {
    return api
      .get<AuditListResponse>("/audits", {
        params: {
          page: params.page,
          page_size: params.page_size ?? 40,
          q: params.q || undefined,
          created_after: params.created_after || undefined,
          created_before: params.created_before || undefined,
          sort: params.sort || undefined,
          dir: params.dir || undefined,
        },
      })
      .then((r) => r.data);
  },
};
